"use strict";
var $dyn;
(function ($dyn) {
    var messaging;
    (function (messaging) {
        /**
         * Framework code for the message center
         * @internal
         */
        var MessageCenterManager;
        (function (MessageCenterManager) {
            MessageCenterManager._cachedPopupLink = null;
            MessageCenterManager._cachedPopupMessage = null;
            MessageCenterManager._cachedPopupContainer = null;
            MessageCenterManager.messages = $dyn.observableArray([]);
            MessageCenterManager.notificationPopupMessage = $dyn.observable("");
            MessageCenterManager.notificationPopupVisible = $dyn.observable(false);
            MessageCenterManager.notifications = {};
            MessageCenterManager.unreadMessageCount = $dyn.observable(0);
            MessageCenterManager.unreadMessageCountChanged = $dyn.observable(false);
            // Method(s) that gets overridden in html-binding-telemetry
            MessageCenterManager.recordMessageCenterTelemetry = function () { };
            MessageCenterManager.messagesEmpty = $dyn.computed(function () {
                return $dyn.value(MessageCenterManager.messages).length === 0;
            });
            MessageCenterManager.messageCount = $dyn.computed(function () {
                return $dyn.format($dyn.label("MessageCenter_MessageCount"), $dyn.value(MessageCenterManager.messages).length);
            });
            MessageCenterManager.seeAllMessagesLinkEnabled = $dyn.computed(function () {
                var linkEnabled = true;
                var currentForm = $dyn.shell.getCurrentRootForm();
                if (currentForm) {
                    var currentFormContext = $dyn.context(currentForm);
                    linkEnabled = !currentFormContext || currentFormContext.FormName !== $dyn.controls.NavigationBar.ActionCenterFormName;
                }
                return linkEnabled;
            });
            // TODO: Bug 1604585: Be able to pass negated computed into binding handler
            MessageCenterManager.messagesNotEmpty = $dyn.computed(function () {
                return $dyn.value(MessageCenterManager.messages).length > 0;
            });
            MessageCenterManager.messageCenterVisible = $dyn.observable(false);
            function ClearMessage(messageData) {
                if ($dyn.value(messageData.isAlert) && $dyn.messaging.isNotification(messageData)) {
                    $dyn.messaging.MessageCenterManager.RemoveAndDismissMessage(messageData.notificationId, true);
                }
                else if ($dyn.messaging.isMessage(messageData)) {
                    $dyn.messaging.MessageCenterManager.RemoveMessage(messageData.messageId);
                }
            }
            MessageCenterManager.ClearMessage = ClearMessage;
            function ExpandMessage(element) {
                var $item = $(element).parents(".messageCenter-item");
                var $itemBody = $item.find(".messageCenter-itemMessage");
                var $extraItems = $item.find(".messageCenter-extraItems");
                if ($itemBody.length || $extraItems.length) {
                    if ($itemBody.hasClass("messageCenter-truncateText")) {
                        // Expand
                        $itemBody.removeClass("messageCenter-truncateText");
                        $extraItems.css("display", "flex");
                        element.classList.add("ChevronUp-symbol");
                        element.classList.remove("ChevronDown-symbol");
                    }
                    else {
                        // Collapse
                        $itemBody.addClass("messageCenter-truncateText");
                        element.classList.add("ChevronDown-symbol");
                        element.classList.remove("ChevronUp-symbol");
                        $extraItems.css("display", "none");
                    }
                }
            }
            MessageCenterManager.ExpandMessage = ExpandMessage;
            /**
             * adds a single message to message center
             */
            function AddMessage(message) {
                AddMessages([message]);
            }
            MessageCenterManager.AddMessage = AddMessage;
            /**
             * adds messages to message center
             */
            function AddMessages(newMessages) {
                var currentMessageList = $dyn.value(MessageCenterManager.messages);
                var newMessagesList;
                if ($dyn.length(newMessages) > 0) {
                    // process any notifications
                    for (var i = 0; i < $dyn.length(newMessages); i++) {
                        var tempMessage = newMessages[i];
                        // todo this should include alert / watch dog in isNotification after conversion
                        if ($dyn.value(tempMessage.isAlert) && messaging.isNotification(tempMessage)) {
                            var newNotification = tempMessage;
                            // check to see if this is an existing notification
                            if (MessageCenterManager.notifications[newNotification.notificationId]) {
                                RemoveAndDismissMessage(newNotification.notificationId, true);
                            }
                            MessageCenterManager.notifications[newNotification.notificationId] = newNotification;
                        }
                    }
                    // reorder so the last message received is always shown first
                    newMessagesList = newMessages.reverse();
                    newMessagesList = newMessagesList.concat(currentMessageList);
                    // only allow 500 messages FIFO
                    if (newMessagesList.length > 500) {
                        var startIndex = newMessagesList.length - 500;
                        var removedItems = newMessagesList.slice(0, startIndex - 1);
                        newMessagesList = newMessagesList.slice(startIndex, newMessagesList.length);
                        for (var j = 0; j < $dyn.length(newMessages); j++) {
                            var tempMessage = newMessages[j];
                            // todo this should include alert / watch dog in isNotification after conversion
                            if ($dyn.value(tempMessage.isAlert) && messaging.isNotification(tempMessage)) {
                                var newNotification = tempMessage;
                                if (MessageCenterManager.notifications[newNotification.notificationId]) {
                                    delete MessageCenterManager.notifications[newNotification.notificationId];
                                }
                                else {
                                    $dyn.logError("Messaging: Tried deleting a message from notifications, but that notification does not exist. Id=%s", newNotification.notificationId);
                                }
                            }
                        }
                    }
                    MessageCenterManager.messages(newMessagesList);
                    MessageCenterManager.unreadMessageCount($dyn.value(MessageCenterManager.unreadMessageCount) + $dyn.length(newMessages));
                    if (MessageCenterManager.unreadMessageCount() !== 0 && !MessageCenterManager._toastActiveFormObserver) {
                        MessageCenterManager._toastActiveFormObserver = $dyn.observe($dyn.activeForm, function (activeForm) {
                            var activeFormContext = $dyn.context(activeForm);
                            if (activeFormContext) {
                                // if the active form is a dialog wait till closed
                                if (activeFormContext.TypeName !== "Dialog") {
                                    MessageCenterManager.unreadMessageCountChanged(true);
                                    MessageCenterManager.notificationPopupVisible(true);
                                    var sound = $("#dynNotificationBackgroundAudio")[0];
                                    if (sound && sound.play) {
                                        try {
                                            if (sound.readyState === 0) {
                                                sound.load();
                                            }
                                            sound.play(); // sometimes causes unidentified exception in product when using Edge or Internet Explorer 11
                                            // tslint:disable-next-line: no-empty
                                        }
                                        catch (err) { }
                                    }
                                    if ($dyn.length(newMessages) > 1) {
                                        MessageCenterManager.notificationPopupMessage($dyn.label("Shell_MultipleNotifications"));
                                    }
                                    else {
                                        var message = newMessages[0];
                                        MessageCenterManager.notificationPopupMessage(message.text);
                                        if (messaging.isMessage(message)) {
                                            SetPopupDataBind(message);
                                        }
                                    }
                                    if (!MessageCenterManager.currentTimer) {
                                        MessageCenterManager.currentTimer = window.setTimeout(function () {
                                            ClearToastVariables();
                                        }, 7500); // The timer is 5 * 1.5 where 1.5 is specified in the animation duration
                                    }
                                }
                                else if (MessageCenterManager.unreadMessageCountChanged()) {
                                    // if a dialog poped and displaying started for toast, close it
                                    ClearToastVariables();
                                }
                            }
                        });
                    }
                }
            }
            MessageCenterManager.AddMessages = AddMessages;
            /**
             * Bind message object to notification popup link
             * @param message Message object to be binded to notificationPopup-link
             */
            function SetPopupDataBind(message) {
                if (message === void 0) { message = null; }
                var navbar = $dyn.ui.getNavBar();
                if (navbar) {
                    var navbarElement = navbar.element;
                    var actionLinkElement = navbarElement.getElementsByClassName("notificationPopup-link")[0];
                    // actionLinkElement might not exist if using the PopoutNavBar
                    if (actionLinkElement) {
                        $dyn.unbind(actionLinkElement);
                        if (message) {
                            $dyn.dataBind(actionLinkElement, new $dyn.DataContext(message, navbarElement.dynContext));
                        }
                        else {
                            actionLinkElement.setAttribute("tabindex", "-1");
                        }
                    }
                }
            }
            MessageCenterManager.SetPopupDataBind = SetPopupDataBind;
            /**
             * Clear timer for the notification popup
             */
            function ClearTimeout() {
                if (MessageCenterManager.currentTimer) {
                    window.clearTimeout(MessageCenterManager.currentTimer);
                    MessageCenterManager.currentTimer = undefined;
                }
            }
            MessageCenterManager.ClearTimeout = ClearTimeout;
            /**
             * Clear variables associated with notification popup
             */
            function ClearToastVariables() {
                MessageCenterManager.unreadMessageCountChanged(false);
                MessageCenterManager.notificationPopupVisible(false);
                SetPopupDataBind();
                ClearTimeout();
                SetPopupElementTabIndex(-1);
                // kill the original observer
                if (MessageCenterManager._toastActiveFormObserver) {
                    MessageCenterManager._toastActiveFormObserver.dispose();
                    MessageCenterManager._toastActiveFormObserver = null;
                }
                if (MessageCenterManager._toastTabbingContainerDispose) {
                    MessageCenterManager._toastTabbingContainerDispose();
                    MessageCenterManager._toastTabbingContainerDispose = undefined;
                }
            }
            MessageCenterManager.ClearToastVariables = ClearToastVariables;
            /**
             * clears all the messages in message center
             */
            function ClearMessages() {
                // clear the messages from the message center
                MessageCenterManager.messages.clear();
                MessageCenterManager.notifications = {};
                MessageCenterManager.unreadMessageCount(0);
                MessageCenterManager.unreadMessageCountChanged(false);
            }
            MessageCenterManager.ClearMessages = ClearMessages;
            function ClearAndDismissMessages() {
                for (var notificationId in MessageCenterManager.notifications) {
                    if (MessageCenterManager.notifications.hasOwnProperty(notificationId)) {
                        $dyn.user().dismissNotification(Number(notificationId));
                    }
                }
                ClearMessages();
            }
            MessageCenterManager.ClearAndDismissMessages = ClearAndDismissMessages;
            /**
             * removes a set of messages from message center
             */
            function RemoveMessages(deleteMessages) {
                for (var i = 0, len = $dyn.length(deleteMessages); i < len; i++) {
                    var message = deleteMessages[i];
                    RemoveMessage(message.messageId);
                }
            }
            MessageCenterManager.RemoveMessages = RemoveMessages;
            /**
             * removes a single message from message center
             * @param { number } messageId - The message Id to remove
             */
            function RemoveMessage(messageId) {
                if (messageId) {
                    for (var i = 0; i < $dyn.length(MessageCenterManager.messages); i++) {
                        var currentMessage = $dyn.value(MessageCenterManager.messages)[i];
                        if (messaging.isMessage(currentMessage) && currentMessage.messageId === messageId) {
                            MessageCenterManager.messages.splice(i, 1);
                            break;
                        }
                    }
                }
            }
            MessageCenterManager.RemoveMessage = RemoveMessage;
            /**
             * removes a single notification from message center
             */
            function RemoveAndDismissMessage(notificationId, dismiss) {
                if (notificationId) {
                    for (var i = 0; i < $dyn.length(MessageCenterManager.messages); i++) {
                        var currentMessage = $dyn.value(MessageCenterManager.messages)[i];
                        if (messaging.isNotification(currentMessage) && currentMessage.notificationId === notificationId) {
                            MessageCenterManager.messages.splice(i, 1);
                            break;
                        }
                    }
                    if (dismiss !== false) {
                        for (var notification in MessageCenterManager.notifications) {
                            if (MessageCenterManager.notifications[notification].notificationId === notificationId) {
                                $dyn.user().dismissNotification(Number(notification));
                                break;
                            }
                        }
                    }
                }
            }
            MessageCenterManager.RemoveAndDismissMessage = RemoveAndDismissMessage;
            /**
             * gets a single message from message center
             */
            function GetMessage(messageId) {
                var msgArr = $dyn.value(MessageCenterManager.messages);
                // tslint:disable-next-line: prefer-for-of
                for (var i = 0; i < msgArr.length; i++) {
                    var currentMessage = $dyn.value(MessageCenterManager.messages)[i];
                    if (messaging.isMessage(currentMessage) && currentMessage.messageId === messageId) {
                        return currentMessage;
                    }
                }
                return null;
            }
            MessageCenterManager.GetMessage = GetMessage;
            function GetNotificationPopupContainer() {
                if (!MessageCenterManager._cachedPopupContainer) {
                    var navbar = $dyn.ui.getNavBar();
                    if (navbar && navbar.element) {
                        var navbarElement = navbar.element;
                        MessageCenterManager._cachedPopupContainer = navbarElement.getElementsByClassName("notificationPopup")[0];
                    }
                }
                return MessageCenterManager._cachedPopupContainer;
            }
            MessageCenterManager.GetNotificationPopupContainer = GetNotificationPopupContainer;
            function GetNotificationPopupLink() {
                if (!MessageCenterManager._cachedPopupLink) {
                    var navbar = $dyn.ui.getNavBar();
                    if (navbar && navbar.element) {
                        var navbarElement = navbar.element;
                        MessageCenterManager._cachedPopupLink = navbarElement.getElementsByClassName("notificationPopup-link")[0];
                    }
                }
                return MessageCenterManager._cachedPopupLink;
            }
            MessageCenterManager.GetNotificationPopupLink = GetNotificationPopupLink;
            function GetNotificationPopupMessage() {
                if (!MessageCenterManager._cachedPopupMessage) {
                    var navbar = $dyn.ui.getNavBar();
                    if (navbar && navbar.element) {
                        var navbarElement = navbar.element;
                        MessageCenterManager._cachedPopupMessage = navbarElement.getElementsByClassName("notificationPopup-message")[0];
                    }
                }
                return MessageCenterManager._cachedPopupMessage;
            }
            MessageCenterManager.GetNotificationPopupMessage = GetNotificationPopupMessage;
            function SetPopupElementTabIndex(index) {
                var popupLink = GetNotificationPopupLink();
                var popupMessage = GetNotificationPopupMessage();
                if (popupLink) {
                    popupLink.setAttribute("tabindex", index.toString());
                }
                if (popupMessage) {
                    popupMessage.setAttribute("tabindex", index.toString());
                }
            }
            MessageCenterManager.SetPopupElementTabIndex = SetPopupElementTabIndex;
            function FocusOnNotificationPopup() {
                $dyn.messaging.MessageCenterManager.SetPopupElementTabIndex(0);
                var messageElement = $dyn.messaging.MessageCenterManager.GetNotificationPopupMessage();
                if (messageElement) {
                    messageElement.focus();
                }
            }
            MessageCenterManager.FocusOnNotificationPopup = FocusOnNotificationPopup;
            $dyn.observe(MessageCenterManager.notificationPopupVisible, function (visible) {
                if (visible) {
                    var tabbingContainer = GetNotificationPopupContainer();
                    if (tabbingContainer) {
                        // remove tabbing container if it exists
                        if (MessageCenterManager._toastTabbingContainerDispose) {
                            MessageCenterManager._toastTabbingContainerDispose();
                            MessageCenterManager._toastTabbingContainerDispose = undefined;
                        }
                        // add tabbing container
                        MessageCenterManager._toastTabbingContainerDispose = $dyn.util.tabbingContainer(tabbingContainer, $dyn.label("FormPersonalization_RegionTitle"));
                    }
                }
            });
            $dyn.observe(MessageCenterManager.messageCenterVisible, function (visible) {
                // when the user opens the message center mark all messages as read
                if (visible) {
                    $(document.body).on("resetShellOnNavigation.dynMessageBarExpanded", function () {
                        MessageCenterManager.messageCenterVisible(false);
                    });
                    MessageCenterManager.recordMessageCenterTelemetry();
                    $dyn.messaging.MessageCenterManager.unreadMessageCount(0);
                    $dyn.messaging.MessageCenterManager.unreadMessageCountChanged(false);
                    var currentMomentUtc = moment.utc();
                    for (var i = 0; i < $dyn.length($dyn.messaging.MessageCenterManager.messages); i++) {
                        var message = $dyn.value($dyn.messaging.MessageCenterManager.messages)[i];
                        if (message.timeStampMomentUtc) {
                            message.elapsedTimeSinceArrival($dyn.format($dyn.label("NavBar_MessageReceived"), $dyn.util.elapsedTimeDisplayText(message.timeStampMomentUtc, currentMomentUtc)));
                        }
                    }
                    var messageCenterContainer_1 = $(".messageCenter")[0];
                    if (messageCenterContainer_1) {
                        // we should wait until the active flyout not change
                        $dyn.microTask(function () {
                            var firstFocusableControl = $dyn.util.findFirstFocusableControl(messageCenterContainer_1);
                            if (firstFocusableControl) {
                                $dyn.log.focus && $dyn.log.focus("Focus: NavBar-> Open message center, executing MicroTask to set focus");
                                $(firstFocusableControl).focus();
                            }
                        });
                    }
                }
                else {
                    $(document.body).off("resetShellOnNavigation.dynMessageBarExpanded");
                }
            });
        })(MessageCenterManager = messaging.MessageCenterManager || (messaging.MessageCenterManager = {}));
    })(messaging = $dyn.messaging || ($dyn.messaging = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=MessageCenterManager.js.map
